module.exports = __webpack_public_path__ + "870ac04d1a1398de00b66cf2f5ccbe7d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/googlesheets.png
// module id = 258
// module chunks = 1